// Documents the add-in produces are marked so Word opens the Jenly task pane
// the next time they are opened. The manifest's task pane action keys on the
// same name (`TaskpaneId`), and the server writes the equivalent reference into
// the reports it assembles.

export const AUTO_SHOW_TASKPANE_SETTING = "Office.AutoShowTaskpaneWithDocument";

/**
 * Sets the auto-show setting on the open document unless it is already set.
 * Saving settings marks the document as changed, so an already-marked document
 * is left alone. Resolves true when the setting was written; never rejects,
 * since the pane opening on its own is a convenience.
 */
export const ensureTaskpaneAutoOpens = (): Promise<boolean> =>
  new Promise((resolve) => {
    try {
      const settings = typeof Office !== "undefined" ? Office.context?.document?.settings : undefined;
      if (!settings) {
        resolve(false);
        return;
      }
      if (settings.get(AUTO_SHOW_TASKPANE_SETTING) === true) {
        resolve(false);
        return;
      }
      settings.set(AUTO_SHOW_TASKPANE_SETTING, true);
      settings.saveAsync((result) => resolve(result.status === Office.AsyncResultStatus.Succeeded));
    } catch {
      resolve(false);
    }
  });
